/**
 * Authorization Modules
 */
const authModules = {
	tl_default: ['tl_default'],
	eo_default: ['eo_default'],
	pm_default: ['pm_default'],
	iv_default: ['iv_default'],
	bb_default: ['bb_default'],
	abs_admin: ['abs_admin'],
	loggedin: ['loggedin'], //only the logged in can access
	notloggedin: [], //only the not logged in can access
	openforall: null, //then all can access
};

export default authModules;
